import { formatDate } from '@/helpers/formatDate';

const DateCell = ({ date }: { date: string }) => formatDate(date);

export default DateCell;
